"use client";

import React, { useState, useRef } from "react";
import Action from "./Action";
import Callout from "@churchofjesuschrist/eden-callout";
import DownloadPane from "@churchofjesuschrist/eden-download-pane";
import { Download as DownloadIcon } from "@churchofjesuschrist/eden-icons";
import styled from "styled-components";
import PropTypes from "prop-types";
import { spacing16, spacing32 } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  componentId: "sc-1iomw3c-0"
})(["position:relative;"]);
const PaddingBox = styled.div.withConfig({
  componentId: "sc-1iomw3c-1"
})(["padding-block-start:", ";padding-block-end:", ";padding-inline-start:", ";padding-inline-end:", ";"], spacing16, spacing32, spacing16, spacing16);
const Download = _ref => {
  let {
    label = "Download",
    items = [],
    ...props
  } = _ref;
  const [active, setActive] = useState(false);
  const forRef = useRef(null);
  const open = () => {
    setActive(true);
  };
  const close = () => {
    setActive(false);
  };
  return /*#__PURE__*/_jsxs(Container, {
    ...props,
    children: [/*#__PURE__*/_jsx(Action, {
      active: active,
      label: label,
      Icon: DownloadIcon,
      onClick: open,
      ref: forRef
    }), /*#__PURE__*/_jsx(Callout, {
      open: active,
      forRef: forRef,
      onClickOutside: close,
      children: /*#__PURE__*/_jsx(PaddingBox, {
        children: /*#__PURE__*/_jsx(DownloadPane, {
          items: items,
          onClose: close
        })
      })
    })]
  });
};
export default Download;
Download.propTypes = {
  /** Hidden text label */
  label: PropTypes.string,
  /** The download items. Item shape:
   * ```js
   * PropTypes.shape({
   *  title: PropTypes.string.isRequired,
   *  items: PropTypes.arrayOf(
   *    PropTypes.shape({
   *      text: PropTypes.string.isRequired,
   *      download: PropTypes.string
   *    })
   *  )
   * })
   * ```
   */
  items: PropTypes.array.isRequired
};